module.exports = "<div class=\"container newFlow\" style=\"position:absolute;top:0;left:0;width:100%;height:100%;background-image:url(/assets/images/csnswbg-1.jpg);background-color:#ffffff;padding-top: 50px;\">\r\n\t<div class=\"alert alert-danger\" *ngIf=\"errorMessage\">\r\n\t\t<strong>Error!</strong> {{errorMessage}}\r\n\t</div>\r\n\t<div>\r\n        <span>\r\n            <i class=\"fa fa-spinner fa-spin\"></i> Signing you in...\r\n\t\t</span>   \r\n\t</div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gateway/gateway.component.html
// module id = 494
// module chunks = 0